module.exports = __webpack_public_path__ + "img/21.c687f0a0.png";